import type { QueryKey } from '@tanstack/react-query'

export const findQueryKey = (id: string): QueryKey => ['useLink', id]
